const ITEMS = [
  "Home & Auto",
  "Life & Health",
  "Medicaid Advisory",
  "Atlanta · Georgia",
  "Independent Agent",
  "Family-First Guidance",
];

const StarDivider = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" className="shrink-0 fill-[color:var(--ns-gold)]/60" aria-hidden="true">
    <path d="M12 2 L14 10 L22 12 L14 14 L12 22 L10 14 L2 12 L10 10 Z" />
  </svg>
);

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden border-y border-[color:var(--ns-line)] py-7"
      aria-label="Coverage highlights"
    >
      <div className="marquee-track flex w-max items-center gap-16 pr-16">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center gap-16" aria-hidden={half === 1}>
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center gap-16">
                <span className="whitespace-nowrap font-serif text-xl italic tracking-wide text-[color:var(--ns-muted)]/80 sm:text-2xl">
                  {item}
                </span>
                <StarDivider />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
